/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ThreadPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACCUlEQVR4nLWUS2sUQRDHR3yA8XEQQYyIghc1BzVeDET3YiC4XY9Z6KmajYKnvYV8g6DmrH4Bcwx+BPHq4t3oSeNNb+asuItEqmc7Jusum0lmGxpmqh+/+ldVV5KUHAB6jkguJ+MY9bq/gCw/gPQnYna/cgCivw4kHWTdGguESC4CyTcDjAWCpJ/i5WOBIOnbfsCBIXNzD0+k6cJ5+67VakeA5AmydiuDAOsakPwBlhfe++Nmc5zPAOnXSiBA8jhWDpJ8cZzPmh0RTwHJ6r4gzHLFkTxqtVpHg8dpNo0s68UFhRrn3EShUBpAslkKAqSvC4/1A6LeMpv3/hiyPhusRif7C8AgDxrNS9Hja0D63B6S/RM1bwLp557HHSB9aoBBapDlpff+cJIkh5BlCUl+9dY2ra2E3mLPP1KBdNE2W0ItFMUl5pWs2+X9aoD0t7WQbfWgU+Ec6FQwmIwQs53JInkTS9NxPmvh+KdGVqKaeprdQMzujawUS8h/EFOFmgaIcxMWiqgGWD4yN2/vyhvreyRpl4SozVfe+5NFbuQusm707F2roO3zvf37UKI2NyDN7kQ1RDl478/sOrsXwAhIF1mWh57bK2AEZCuGK8R8wHpfsZTPiXP52bBO0h4FANZ3ZZV8n59fOH3gEA2DAEnHNfKrlQJ2QkJTQ52sHGAjvHjrLcOcIGkPivlfyLu6tONsg0IAAAAASUVORK5CYII=)
 */
export const ThreadPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M19 14a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 1-1ZM12 19c0-.22.03-.44.08-.66a.56.56 0 0 0-.21-.58l-8.84-6.22a1 1 0 0 0-1.3.13l-.69.69a1 1 0 0 0 0 1.41l9.2 9.2a1 1 0 0 0 1.4 0l.36-.36a1 1 0 0 0 0-1.41l-.35-.36.37-.37a.56.56 0 0 0 .12-.56A3 3 0 0 1 12 19ZM15 16h.16c.33 0 .56-.32.3-.53a.98.98 0 0 0-.07-.06L6.9 9.76a1 1 0 1 0-1.1 1.66l7.3 4.88c.17.1.39.1.56.02.4-.2.86-.32 1.34-.32ZM15.82 13.39c.25.17.6.07.77-.17.12-.17.26-.32.42-.46.29-.26.32-.76 0-.98L9.73 6.93a1 1 0 0 0-1.11 1.66l7.2 4.8ZM12 2.81a1 1 0 0 1 0-1.41l.36-.36a1 1 0 0 1 1.41 0l9.2 9.2a1 1 0 0 1 0 1.4l-.7.7a1 1 0 0 1-1.3.13l-9.54-6.72a1 1 0 0 1-.08-1.58l1-1L12 2.8Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
